function clearSelectedTabs() {
  let tabs = document.getElementsByClassName("screen-tab");
  for (let i=0; i<tabs.length; i++) tabs[i].classList.remove("selected");
}

function markSelectedTab(name) {
  let candidates = document.getElementsByClassName(name);
  if (candidates.length > 0) {
    candidates[0].classList.add("selected");
  }
}

export default function markScreenSelected(name) {
  clearSelectedTabs();
  if (name) markSelectedTab(name);
}
